<!--应收单-->
<template>
  <div class="app-container">
    <el-card class="box-card">
      <dynamic-search :data="tableFilterList(tableHead)" @search="dataTableSearch">
        <template v-slot:next>
            <el-button icon="el-icon-upload2" @click="downloadExcel()">导出</el-button>
          <!-- <el-button icon="el-icon-plus" @click="add()">新增</el-button> -->
        </template>
      </dynamic-search>
      <edit-data-table
        :head="tableHead"
        :data.sync="list"
        :config="{trigger: 'click', mode: 'cell'}"
        :total="total"
        :offset="offset"
        :page="page"
        :loading="loading"
        stripe
        border
        @handlePageChange="dataTablePageChange"
        @handleSizeChange="dataTableSizeChange"
      >
      <template v-slot:moneyId="scope">
          <div v-for="item in receiptTypes" :key="item.id">
            <span v-if="scope.row.moneyId === item.value">{{ item.label }}</span>
          </div>
      </template>
        <template #toolbar="scope">
           <!-- <el-button type="text" size="mini" icon="el-icon-circle-plus-outline" v-if="!scope.row.invoicingApply" @click="add(scope.row)"></el-button> -->
          <el-button type="text" size="mini" icon="el-icon-view" @click="edit(scope.row)"></el-button>
        </template>
      </edit-data-table>
    </el-card>
  </div>
</template>

<script>
import "@/components/EditDataTable";
import DynamicSearch from "@/components/DynamicSearch";
import DataTableMixin from "@/mixins/DataTableMixin";
import {tableSataus} from '@/views/bill/mixins/status'
import initDict from "@/mixin/initDict";
import { downloadExcel } from "@/api/bill/ProjectPlan";
export default {
  name: "PartnerBudgetTask",
  components: {
    DynamicSearch
  },
  mixins: [DataTableMixin,tableSataus,initDict],
  data() {
    return {
      tableHead: [
        {
          label: "单据编号",
          prop: "code",
        },
        {
          label: "合同编号",
          prop: "paymentDetails.contract.code"
        },
        {
          label: "经营人",
          prop: "paymentDetails.contract.personManage.name"
        },
        {
          label: "日期",
          prop: "paymentDetails.contract.created"
        },
        {
          label: "签约客户",
          prop: "paymentDetails.contract.customerSigning.name",
           query: {
            type: "input"
          },
        },
        {
          label: "应收金额",
          prop: "totals",
        },
        {
          label: "款项说明",
          prop: "moneyId",
          slot: "moneyId"
        },
         {
          label: "状态",
          prop: "billState",
            formatter: (state) => {
              return this.fomatterState(state)
            },
          query: {
            type: "select",
            data: [
              { label: "未开票",value: "1" },
              { label: "已开票",value: "2" },
              { label: "已收款",value: "3" }
            ],
          },
        }
      ],
      receiptTypes: []
    };
  },
  created() {
    // 列表数据初始化
    this.$nextTick(() => {
      this.dataTableInit();
    });
     this.getDict("RECEIPT").then(res => {
      this.receiptTypes = res.data;
    });
  },
  methods: {
      // 导出
      downloadExcel() {
        const obj = Object.keys(this._query)
      const query = {customer: this._query[obj[0]],state: this._query[obj[1]]}
        downloadExcel('/receivable/exportReceivableExcle',query,'应收单')
      },
      fomatterState(state) {
           switch (state) {
        case 1:
          return "未开票";
        case 2:
          return "已开票";
        case 3:
          return "已收款";
      }
      },
    dataTableBeforeInit() {
      this._url = "/receivable";
      const params = { page: this.page, size: this.offset};
         console.log('ss',this._query);
      const obj = Object.keys(this._query)[0]
      const query = {customer: this._query[obj], state: this._query[Object.keys(this._query)[1]] }
      this._params = Object.assign(params, query);
      return true;
    },
    dynamicSearch() {},
    // 增加开票申请
     add(row) {
         const data  = JSON.stringify(row);
        this.$router.push({path: "invoice/form",query: { data: data,isEdit: 1}});
    },
    // 查看详情
    edit(row) {
      this.$router.push({path: "receivable/form" ,query: { id: row.id,isEdit: 0}});
    },
  }
};
</script>

<style scoped lang="scss">
</style>
